import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { DexVehicleFormBootstrapView, VehicleRegistrationInquiry } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { pruneDexFields } from '../utils';
import { EventWorkspacePanelDexFormPrefill } from '../../panels/workspace-panel-types';
import {
    DexQueriessubmitResource,
    DexQuerySubmissionVehicleRegistrationInquiry,
} from '@mark43/dex-api';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';
import { useResetDexFormOnPrefillValuesUpdate } from './use-reset-dex-form-on-prefill-values-update';

export function DexVehicleForm({
    formBootstrapView,
    dexFormEventPanelPrefillValues,
}: {
    formBootstrapView: DexVehicleFormBootstrapView;
    dexFormEventPanelPrefillValues?: EventWorkspacePanelDexFormPrefill;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const prefilledEntityValues =
        pruneDexFields(formBootstrapView, dexFormEventPanelPrefillValues?.vehicle) ?? {};
    const defaultValues = {
        params: {
            ...formBootstrapView.defaultValues,
            ...prefilledEntityValues,
        },
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<VehicleRegistrationInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
        prefilledEntityValues,
    });

    useResetDexFormOnPrefillValuesUpdate({
        form,
        prefillValues: dexFormEventPanelPrefillValues?.vehicle,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<VehicleRegistrationInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitVehicleQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/vehicle_registration_inquiry',
            data: buildDexQuerySubmission(
                formModel
            ) as DexQuerySubmissionVehicleRegistrationInquiry,
        });
    });

    return (
        <DexForm
            eventNumber={dexFormEventPanelPrefillValues?.eventNumber}
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
